export const iconFontAwesomeDevicesHardwareCarBattery = (
	<i className="fa-solid fa-car-battery"></i>
);
